<template>
    <div id="monitor-menu" 
        class="main_treeview"
    >
        <section class="menu_ctrl">
            <span class="text">{{ $t('__monitor.top_hint') }}</span>
            <!-- 選擇表格 右側的icon (導覽列收合功能icon暫時拿掉) -->
            <!-- <div class="icon-container">
                <QpeTooltip>
                    <template #hovered_item>
                        <v-icon 
                            color="white"
                            @click="close_all"
                        >
                            icon-unfold-less
                        </v-icon>
                    </template>
                    <template #tooltip_content>
                        <span>{{ $t('__map_obs.close_all_tree') }}</span>
                    </template>
                </QpeTooltip>
            </div> -->
        </section>
        <div class="monitor_treeview">
            <TreeView
                v-if="init_items.length > 0" 
                ref="child_treeview"
                :current_tab="'monitor'"
                :init_items="init_items"
                :checked_selectors="checked_selectors"
                :init_opened_layers="init_opened_layers"
                :check_function="change_monitor_type"
            />
        </div>
    </div>
</template>

<script>
    import { default_monitor_value, ignore_menu_list } from '@/config/monitor_config.js';
    import { monitor_ajax } from '@/utils/monitor/monitor.js';
    import { MENU_ICON } from '@/config/menu_config.js';
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import TreeView from '../../tree_view.vue'
    export default {
        name: 'MonitorMenu',
        
        components: {
            TreeView,
            QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
        },
        
        data() {
            return {
                init_opened_layers: [], // 預設右側導覽列要打開的選項
                init_items: [], // 右側導覽列選單資料
                checked_selectors: {},
                init_checked_selector: {},
            }
        },

        computed: {
            ...mapState([
                'client_name',
                'is_short_term_precp_occur',
                'language',
                'i18n_language',
            ]),

            ...mapState('monitor', [
                'monitor_type'
            ]),

            ...mapState('case', [
                'case_selected',
            ]),

            ...mapGetters('case', [
                'is_case_mode'
            ]),

            monitor_menu_get_api_param() {
                return {
                    case_id: this.case_selected?.case_id,
                    lang: this.language,
                }
            }
        },

        watch: {
            language: {
                immediate: true,
                handler() {
                    this.initialize()
                }
            }
        },

        methods: {
            ...mapMutations({
                set_i18n_language: 'set_i18n_language',
            }),

            ...mapMutations('monitor', [
                'set_monitor',
                'set_reference_map',
            ]),

            async initialize() {
                try {
                    const response = await monitor_ajax(this.client_name, this.monitor_menu_get_api_param);
                    this.data_cleaning(response);
                    this.set_i18n_language(this.language)

                    if (this.init_checked_selector) {
                        this.set_monitor(this.init_checked_selector)    
                    } else {
                        this.set_monitor({ value: default_monitor_value })
                        const default_checked_selector = Object.values(this.checked_selectors)
                            .find(({ value, text }) => value === default_monitor_value || text === this.$t('__rainfall.default_name'))
                        default_checked_selector.checked = true
                    }

                } catch(err) {
                    console.error(err)
                }

                if (this.is_short_term_precp_occur) {
                    const SHORT_TERM_PRECP_SELECTOR_KEY = 'monitor_248'
                    this._force_change_monitor_page_by_selector_key(SHORT_TERM_PRECP_SELECTOR_KEY)
                }
            },
            
            data_cleaning(response) {
                const _data = typeof response.data === 'object' ? response.data : JSON.parse(response.data); 
                this.reconstruct_monitor_data(_data.data);
                this.compute_reference_map(_data.data);
            },

            reconstruct_monitor_data(menu_data) {
                this.init_opened_layers = Object.keys(menu_data)
                const items_groupby_layer1 = this.init_opened_layers.map(node_name => {
                    return {
                        'id': name + '_root',
                        'name': node_name, 
                        'values': menu_data[node_name]
                    }
                })
                
                const layers = this.init_opened_layers.map((layer_name, i) => {
                    const results_groupby_layer1 = this._generate_layer2(items_groupby_layer1[i]);
                    const main_item = {
                        'id': layer_name + '_root',
                        'name':layer_name, 
                        'node':true, 
                        'layer1':true, 
                        'radio_name': `${layer_name}root`,
                        'children': results_groupby_layer1,
                        'icon': MENU_ICON[layer_name]
                    }
                    return main_item
                })

                this.init_opened_layers = this.init_opened_layers.map(x => x + '_root');
                this.checked_selectors = this._generate_checked_property(menu_data);
                this.init_checked_selector = this._get_default_checked_selector_value(this.checked_selectors)
                this.init_items = layers;
            },

            _generate_layer2(layer1_group_data) {
                return layer1_group_data['values']
                    .map((group_datum, i) => {
                        const value = group_datum['value']
                        if(ignore_menu_list.includes(value)) {
                            return
                        }
                        return {
                            'id': `monitor_${value}`,
                            'name': group_datum['text'],
                            'node': false, 
                            'type': 'cross_type_single_radio',
                            'layer1': false,
                            'radio_name': layer1_group_data['name'],
                            'index': i,
                        }
                    })
                    .filter(group_datum => group_datum)
            },

            _generate_checked_property(all_menu_items) {
                return Object.values(all_menu_items).reduce((all_object, selectors) => {
                    const menu_objects_by_nodes = selectors.reduce((accumlator_objects, selector) => {
                        const value = selector['value']
                        const id = `monitor_${value}` 
                        const custom_header = selector['index'] || []
                        const is_custom_monitor = selector['from_qadmin']  // 有提供模組化功能
                        const checked_property = {
                            id,
                            checked: this.monitor_type ? value === this.monitor_type : selector['default_checked'] === true,
                            is_custom_monitor,
                            custom_header
                        }
                        return {
                            ...accumlator_objects, 
                            [id]: { 
                                ...selector, 
                                ...checked_property 
                            }
                        } 
                    }, {})

                    return { ...all_object, ...menu_objects_by_nodes }
                }, {})
                
            },

            _get_default_checked_selector_value(selectors) {
                return Object.values(selectors).find(({checked}) => checked)
            },

            _force_change_monitor_page_by_selector_key(selector_key) {
                Object.values(this.checked_selectors).forEach(selector => selector.checked = false)
                this.set_monitor(this.checked_selectors[selector_key])
                this.checked_selectors[selector_key]['checked'] = true
            },

            compute_reference_map(menu_data) {
                const reference_map = Object.values(menu_data)
                    .flat()
                    .reduce((accumulator, datum) => {
                        const { value, reference } = datum

                        if (!reference) return accumulator

                        return {
                            ...accumulator,
                            [value]: reference
                        }
                    }, {})
                this.set_reference_map(reference_map)
            },

            change_monitor_type(selector_key) {
                this.set_monitor(this.checked_selectors[selector_key])
            },
            
            close_all() {
                this.$refs.child_treeview.close_all_trees();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .monitor_treeview {
        overflow-y: auto;
        height: calc(100vh - 30px);
        background: var(--base-gray);
    }

    .menu_ctrl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 3px;
        background: var(--base-gray-darken);
        touch-action: none;
    }

    .text {
        color: var(--grey-pipe);
    }
</style>